import { render, staticRenderFns } from "./WBtnLaunch.vue?vue&type=template&id=4b3f588a&scoped=true&"
import script from "./WBtnLaunch.vue?vue&type=script&lang=js&"
export * from "./WBtnLaunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3f588a",
  null
  
)

export default component.exports